/* eslint-disable react/prop-types */
import React from 'react';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { UilClock } from '@iconscout/react-unicons';
import classNames from 'classnames';

const TimePicker = ({
  icon,
  hideIcon = false,
  options,
  inputRef,
  className,
  containerClassName,
  children,
  ...rest
}) => {
  return (
    <div
      className={classNames('flatpickr-input-container', containerClassName)}
    >
      <Flatpickr
        className={classNames('form-control', className, {
          'ps-6': !hideIcon
        })}
        options={{
          enableTime: true,
          noCalendar: true,
          dateFormat: 'H:i',
          time_24hr: true,
          ...options
        }}
        ref={inputRef}
        {...rest}
      />
      {icon ? (
        <>{icon}</>
      ) : (
        !hideIcon && <UilClock className="flatpickr-icon text-700" size={16} />
      )}
      {children}
    </div>
  );
};

export default TimePicker;
